import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import styles from './styles.module.css'
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker, DatePicker } from '@material-ui/pickers';
import spanish from '../../../common/language/spanis';
import english from '../../../common/language/english';
import layout from '../../../common/layout';

let lang = spanish;

class ReservationInformation extends Component {


    componentWillMount() {
        const {language}= this.props;
        if (language === 'spanish') {
            lang = spanish;
        }
        else {
            lang = english;
        }
    }

    componentWillReceiveProps(next) {
        // console.log(next);
        if (next.language === 'spanish') {
            lang = spanish;
        }
        else {
            lang = english;
        }
    }

    render() {
        const roomTypes = lang.form.reservationInformation.roomsTypes.map((item, key) =>
        <MenuItem key={key}  value={item}>{item}</MenuItem>
        );
        const destinations = lang.form.reservationInformation.destinations.map((item, key) =>
        <MenuItem key={key}  value={item}>{item}</MenuItem>
        );
        const { city, roomType, persons, incomingDate, outcomingDate } = this.props.state;
        const {typeReservation} = this.props;
        return (
            <div>
                <h3>{lang.form.reservationInformation.title} <span style={{color:layout.gold}}>{typeReservation === 'cruiser'?lang.form.cruiser:lang.form.hotel}</span></h3>
                {/* 
                ====================================
                DESTINO 
                ====================================
                */}
                <TextField
                    select
                    id="city"
                    className={styles.city}
                    variant="outlined"
                    label={lang.form.reservationInformation.inputCity}
                    value={city}
                    onChange={this.props.handleChange('city')}
                >
                    {destinations}
                </TextField>
                {/* 
                ====================================
                Tipo de habitación y numero de personas
                ====================================
                */}
                <div className={styles.rowContainer}>
                    <div style={{ flex: 0.5, paddingRight: 5 }}>
                        <TextField
                            disabled
                            // select
                            className={styles.city}
                            variant="outlined"
                            label={lang.form.reservationInformation.inputRoomType}
                            // value={roomType}
                            value="not apply"
                            onChange={this.props.handleChange('roomType')}
                        >
                            {roomTypes}
                        </TextField>
                    </div>
                    <div style={{ flex: 0.5, paddingLeft: 5 }}>
                        <TextField
                            id="persons"
                            className={styles.city}
                            type="number"
                            variant="outlined"
                            label={lang.form.reservationInformation.inputPersonsNumber}
                            value={persons}
                            onChange={this.props.handleChange('persons')}
                        />
                    </div>
                </div>
                {/* 
                ====================================
                Fechas
                ====================================
                */}
                <div className={styles.rowContainer} >
                    <div style={{ flex: 0.5, paddingRight: 5 }}>
                        <MuiPickersUtilsProvider 
                        utils={DateFnsUtils}
                        >
                            <KeyboardDatePicker
                                style={{ width: '100%' }}
                                margin="normal"
                                id="incomingDate"
                                label={lang.form.reservationInformation.inputIncommingDate}
                                value={incomingDate}
                                onChange={(date) => { this.props.handleChangeInDate(date) }}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date'
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <div style={{ flex: 0.5, paddingLeft: 5 }}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                style={{ width: '100%' }}
                                margin="normal"
                                id="outcomingDate"
                                label={lang.form.reservationInformation.inputOutcommingDate}
                                value={outcomingDate}
                                onChange={(date) => { this.props.handleChangeOutDate(date) }}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date'
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    language: state.LanguageReducer.language,
    typeReservation: state.typeReservationReducer.typeReservation,
  });
  
  const mapDispatchToProps = dispatch => ({

  });
  
  // make this component available to the app
  export default connect(mapStateToProps, mapDispatchToProps)(ReservationInformation);
  
  